import React from "react";
import { useDroppable } from "@dnd-kit/core";
import KanbanCard from "./KanbanCard";
import { IconPlus } from "../common/Icons";
import styles from "./Kanban.module.css";

export default function KanbanColumn({ column, onCardClick, onCardMetrics, onAdd }) {
  const { setNodeRef, isOver } = useDroppable({ id: column.key });

  return (
    <div className={styles.column}>
      <div className={styles.colHead}>
        <span>{column.title}</span>
        <span className={styles.count}>{column.cards.length}</span>
      </div>
      <div
        ref={setNodeRef}
        className={`${styles.dropZone} ${isOver ? styles.over : ""}`}
      >
        {column.cards.map((card) => (
          <KanbanCard key={card.id} card={card} onClick={() => onCardClick(card)} onMetrics={onCardMetrics} />
        ))}
        {column.key === "backlog" && (
          <button className={styles.addCard} onClick={() => onAdd(column.key)}>
            <IconPlus width={14} height={14} /> карточка
          </button>
        )}
      </div>
    </div>
  );
}
